import React, { useState } from 'react';
import { AllowedTenant } from '../../types/auth';
import { t } from '../../i18n/t';

interface TenantSelectStepProps {
  allowedTenants: AllowedTenant[];
  onSubmit: (tenantId: number) => void;
  onBack: () => void;
  isSubmitting: boolean;
  error: string | null;
}

export function TenantSelectStep({
  allowedTenants,
  onSubmit,
  onBack,
  isSubmitting,
  error,
}: TenantSelectStepProps) {
  const [selectedTenantId, setSelectedTenantId] = useState<number | null>(
    () => allowedTenants[0]?.tenantId ?? null,
  );

  function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    if (selectedTenantId !== null) onSubmit(selectedTenantId);
  }

  return (
    <form onSubmit={handleSubmit} className="login-form">
      <p className="login-form__hint">{t('auth.selectTenant')}</p>
      {error && (
        <div className="login-form__error" role="alert">
          {error}
        </div>
      )}
      <div className="tenant-select">
        <select
          id="tenant-select-dropdown"
          className="tenant-select__dropdown"
          aria-label={t('auth.selectTenant')}
          value={selectedTenantId ?? ''}
          onChange={(e) => setSelectedTenantId(Number(e.target.value))}
          disabled={isSubmitting}
        >
          {allowedTenants.map((tenant) => (
            <option key={tenant.tenantId} value={tenant.tenantId}>
              {tenant.displayName}
            </option>
          ))}
        </select>
      </div>
      <div className="login-form__actions">
        <button
          type="button"
          onClick={onBack}
          disabled={isSubmitting}
          className="login-form__secondary"
        >
          {t('common.back')}
        </button>
        <button
          type="submit"
          disabled={isSubmitting || selectedTenantId === null}
          className="login-form__submit"
        >
          {isSubmitting ? t('auth.submitting') : t('auth.submit')}
        </button>
      </div>
    </form>
  );
}
